"use client";

import { mutate } from "swr";
import { ImageAPI, ImageExcludeFromGroupRequest } from "@/restapi/image";

export const useImageExcludeFromGroup = () => {
  const submit = async (request: ImageExcludeFromGroupRequest) => {
    try {
      // APIにPOSTリクエストを送信してデータを取得
      const res = await ImageAPI.excludeFromGroupRequest(request);

      // キャッシュを更新
      mutate(`exclude-from-group-${request.imageId}`, res, false);

    } catch (err) {
      console.error("Failed to submit post:", err);
      throw err; // エラー処理
    }
  };

  return {
    submit,
  };
};
